import styles from './Loader.module.scss';

export default function Loader({minHeight = '100%'}) {
  return (
    <div className={styles.loaderWrapper} style={{minHeight}}>
      <div className={styles.loader} />
    </div>
  );
}
